/**
 * A choice as a vertical list of radio buttons (Chad's form rule: every choice is a vertical list).
 * options: [{ value, label, hint? }]. value is compared as text.
 */
export default function Radios({ name, value, options, onChange, disabled = false, className = '' }) {
  return (
    <div role="radiogroup" className={`grid justify-items-start gap-1.5 ${className}`}>
      {options.map((o) => (
        <label key={String(o.value)} className={`flex items-start gap-2 text-sm ${disabled || o.disabled ? 'cursor-not-allowed opacity-70' : 'cursor-pointer'}`}>
          <input type="radio" name={name} value={String(o.value)} checked={String(value ?? '') === String(o.value)} disabled={disabled || o.disabled}
            onChange={() => onChange(o.value)} className="mt-0.5 accent-[#00A79D]" />
          <span>{o.label}{o.hint && <span className="block text-xs text-[var(--text-secondary)]">{o.hint}</span>}</span>
        </label>
      ))}
    </div>
  );
}
